import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=ece9ccc2"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece9ccc2')) {
      api.createRecord('ece9ccc2', component.options)
    } else {
      api.reload('ece9ccc2', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=ece9ccc2", function () {
      api.rerender('ece9ccc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/Register.vue"
export default component.exports